/* TelaPersonalizzata · "Stampe" e "Stampe foto" aprono subito la scelta delle foto.
 * Ogni link a /pages/configuratore-foto (menu, home, piè di pagina) apre la galleria del telefono o del computer.
 * Scelte le foto, le passa al configuratore (IndexedDB, come prima) e lo apre:
 * lì compare subito il menu con misura e carta. Nessuna pagina in mezzo, nessuna finestra del browser. */
(() => {
  'use strict';
  const destination = '/pages/configuratore-foto';
  if (location.pathname === destination) return;

  const dbName = 'tp-direct-create';
  const storeName = 'handoffs';
  const productId = 15979180228942;
  const maxFiles = 300;
  let chooser;
  let busy = false;

  function openDb() {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open(dbName, 1);
      request.onupgradeneeded = () => {
        if (!request.result.objectStoreNames.contains(storeName)) {
          request.result.createObjectStore(storeName, { keyPath: 'id' });
        }
      };
      request.onsuccess = () => resolve(request.result);
      request.onerror = () => reject(request.error);
    });
  }

  async function save(record) {
    const db = await openDb();
    try {
      await new Promise((resolve, reject) => {
        const tx = db.transaction(storeName, 'readwrite');
        tx.objectStore(storeName).put(record);
        tx.oncomplete = resolve;
        tx.onerror = () => reject(tx.error);
        tx.onabort = () => reject(tx.error);
      });
    } finally {
      db.close();
    }
  }

  // Velo leggero mentre le foto passano al configuratore (con tante foto può servire qualche secondo).
  function showVeil(count) {
    const veil = document.createElement('div');
    veil.setAttribute('data-tpf-veil', '');
    veil.setAttribute('role', 'status');
    veil.setAttribute('aria-live', 'polite');
    veil.style.cssText = 'position:fixed;inset:0;z-index:2147483600;display:flex;align-items:center;justify-content:center;padding:24px;background:rgba(25,60,53,.55);font:600 16px/1.4 TPR2Lato,Lato,Arial,sans-serif;color:#193C35;';
    veil.innerHTML = '<div style="display:flex;align-items:center;gap:14px;padding:18px 22px;border-radius:14px;background:#FFFDF9;box-shadow:0 18px 50px rgba(0,0,0,.25)">' +
      '<span style="width:26px;height:26px;border-radius:50%;border:3px solid #EEF2E9;border-top-color:#A43E29;animation:tpfpick 1s linear infinite"></span>' +
      '<span>' + (count === 1 ? 'Apro la tua foto…' : 'Apro le tue ' + count + ' foto…') + '</span></div>' +
      '<style>@keyframes tpfpick{to{transform:rotate(360deg)}}</style>';
    document.body.appendChild(veil);
    return veil;
  }

  function getChooser() {
    if (chooser) return chooser;
    chooser = document.createElement('input');
    chooser.type = 'file';
    chooser.accept = 'image/jpeg,image/png,image/webp,.jpg,.jpeg,.png,.webp';
    chooser.multiple = true;
    chooser.hidden = true;
    chooser.addEventListener('change', async () => {
      const all = Array.from(chooser.files || []);
      chooser.value = '';
      if (!all.length || busy) return;
      busy = true;
      const files = all.slice(0, maxFiles);
      const veil = showVeil(files.length);
      try {
        const id = crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(16).slice(2)}`;
        await save({
          id,
          createdAt: Date.now(),
          product: { id: productId, handle: 'stampa-foto-configuratore' },
          skipped: all.length - files.length,
          files: files.map((file) => ({ name: file.name, type: file.type, lastModified: file.lastModified, blob: file }))
        });
        location.assign(`${destination}?tp_handoff=${encodeURIComponent(id)}`);
      } catch (error) {
        // Troppe foto per la memoria del browser: il cliente le sceglie direttamente nel configuratore.
        console.error('TP photo direct picker', error);
        location.assign(`${destination}?tp_foto_err=1`);
      }
    });
    document.body.appendChild(chooser);
    return chooser;
  }

  // Tornando indietro dal configuratore la pagina può essere quella conservata dal browser: via il velo.
  window.addEventListener('pageshow', (event) => {
    if (!event.persisted) return;
    busy = false;
    document.querySelectorAll('[data-tpf-veil]').forEach((veil) => veil.remove());
  });

  document.addEventListener('click', event => {
    const link = event.target.closest('a[href]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin || url.pathname !== destination || url.search || url.hash) return;
    event.preventDefault();
    getChooser().click();
  });
})();